import { render, staticRenderFns } from "./PieExtended.vue?vue&type=template&id=56abc306"
import script from "./PieExtended.vue?vue&type=script&lang=js"
export * from "./PieExtended.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports